<refactor-card-header>
  <div class="uploaded-modal">
    <h3>{{'LABELS.FILES_LOADED' | translate }}</h3>
    <div class="row">
      <!-- <div *ngFor="let file of uploadedFiles; let i = index">
        <a class="send-docs" [href]="getFileUrl(file)" target="_blank"> -->
          <div class="row" *ngIf="uploadedFile">
            <a class="send-docs" [href]="fileUrl" target="_blank">
          <ion-icon name="document-attach-outline" class="icon"></ion-icon>
          <!--{{ file.name }}-->
          {{ uploadedFile }}
        </a>
      <!--   <ion-icon name="close-circle-outline" (click)="removeFile(i)" class="icon-close"></ion-icon> -->
      <ion-icon name="close-circle-outline" (click)="removeFile()" class="icon-close"></ion-icon>
      </div>
    </div>

    <h3>{{'LABELS.ACTIONS' | translate }}</h3>
    <div class="row">
      <input type="checkbox" class="check-actions" id="refactor" [checked]="selectedAction === 'refactor'"
        (change)="onSelect('refactor')" [(ngModel)]="refactor" />
      <label for="refactor" class="label-check-actions">{{'ACTIONS.REFACTOR' | translate }}</label>

      <input type="checkbox" class="check-actions" id="modernize" [checked]="selectedAction === 'modernize'"
        (change)="onSelect('modernize')" [(ngModel)]="modernize" disabled="true"/>
      <label for="modernize" class="label-check-actions">{{'ACTIONS.MODERNIZE_JAVA' | translate }}</label>

      <input type="checkbox" class="check-actions" id="migrate" [checked]="selectedAction === 'migrate'"
        (change)="onSelect('migrate')" [(ngModel)]="migrate" disabled="true"/>
      <label for="migrate" class="label-check-actions">{{'ACTIONS.MIGRATE_LANGUAJE' | translate }}</label>
    </div>
  </div>

  <div class="container-begin-button">
    <button class="begin-button" [disabled]="!isAnyCheckboxSelected()" (click)="generateCode()">{{'BUTTONS.START' | translate }}</button>
    <a class="return-update-file" (click)="returnfileUpload()">{{'NAVIGATION.GO_TO_FILE_UPLOAD' | translate }}</a>
  </div>
</refactor-card-header>